import { useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { FlexCenterWrapper } from "../../../../../../../../components/DefaultNoDataWrapper";
import Flex from "../../../../../../../../components/Flex";
import LoadingOverlay from "../../../../../../../../components/LoadingOverlay";
import { ScrollArea } from "../../../../../../../../components/ScrollBar";
import useDisclosure from "../../../../../../../../hooks/use-disclosure";
import InsuranceCardPreviewModal from "./InsuranceCardPreviewModal";
import { useGetInsuranceByPatientId } from "../../../../../../../../queries/insurance/use-get-patient-insurance-patient-uuid";
import { useUpdatePatientInsuranceToPrimary } from "../../../../../../../../queries/insurance/use-update-patient-insurance-to-primary";
import { getXtenantId } from "../../../../../../../../utils/utils";
import UpsertInsuranceFormModal from "../../../patient-chart-new/demographics/insurance/UpsertInsuranceFormDrawer";
import InsuranceCard from "./InsuranceCard";

const PatientInsuranceNew = () => {
  const { patientId } = useParams() as { patientId: any };
  const isVisitNotePage = window.location.pathname.includes("/visit-note");
  const editPatientInsuranceDisclosure = useDisclosure();
  const viewCardPhotosDisclosure = useDisclosure();
  const {
    data: insuranceData,
    isLoading,
    isRefetching,
    isFetching,
  }: any = useGetInsuranceByPatientId(patientId);

  const { mutateAsync: updatePatientInsuranceToPrimary } =
    useUpdatePatientInsuranceToPrimary();
  const queryClient = useQueryClient();

  // Takes the full insurance `item` from InsuranceCard and builds the
  // mutation payload. Backend flips orderOfBenefits → PRIMARY server-side.
  function updatePatientInsuranceToPrimaryFunction(item: any) {
    if (!item?.uuid || !patientId) return;
    updatePatientInsuranceToPrimary({
      patientInsuranceId: item.uuid,
      patientUuid: patientId,
      xTENANTID: getXtenantId(),
    }).then(() => {
      queryClient.invalidateQueries({
        queryKey: ["get-insurance-by-patient-id"],
      });
      queryClient.invalidateQueries({
        queryKey: ["patient"],
      });
    });
  }

  const handleEditInsurance = (item: any) => {
    // console.log("item", item);

    editPatientInsuranceDisclosure.open({
      patientInsurances: [
        {
          ...item,
          insurancePayer: {
            payerId: {
              value: item?.insurancePayer?.payerId,
              label: item?.insurancePayer?.payerName ?? "",
            },
          },
          planId: item?.planId
            ? {
                value: item?.planId,
                label: item?.planName,
              }
            : undefined,

          provider: Object.keys(item?.provider ?? {})?.length
            ? {
                value: Object.keys(item?.provider)[0],
                label: Object.values(item?.provider)[0],
              }
            : undefined,
        },
      ],
    });
  };

  return insuranceData?.content?.length ? (
    <ScrollArea height={"100%"} width={"100%"}>
      <UpsertInsuranceFormModal
        disClosureHost={editPatientInsuranceDisclosure}
        title="Edit Insurance"
      />
      <InsuranceCardPreviewModal disclosureHost={viewCardPhotosDisclosure} />
      <Flex gap="12px" flexDirection={"column"} p="12px">
        {insuranceData.content.map((item: any) => (
          <InsuranceCard
            key={item?.orderOfBenefits}
            item={item}
            onUpdatePatientInsuranceToPrimary={
              updatePatientInsuranceToPrimaryFunction
            }
            onEditInsurance={handleEditInsurance}
            onViewCardDetails={(cardItem: any) =>
              viewCardPhotosDisclosure.open(cardItem)
            }
            minimized={isVisitNotePage}
          />
        ))}
      </Flex>
    </ScrollArea>
  ) : (
    <FlexCenterWrapper>
      {" "}
      <LoadingOverlay isLoading={isFetching || isRefetching || isLoading} />
    </FlexCenterWrapper>
  );
};

export default PatientInsuranceNew;
